import { WorkflowTask } from "./WorkflowTask";

export class Workflow{
    id: Nullable<string>;
    statusId: Nullable<number>;
    workflowTypeId: Nullable<number>;
    label: Nullable<string>;
    environments: Nullable<string>;
    workflowData: Nullable<string>;
    workflowTaskTypes: Nullable<string>;
    tasks: WorkflowTask[];

    constructor(id: string = "", statusId: number = 0, workflowTypeId: number = 0, label: string = ""){
        this.statusId = statusId;
        this.workflowTypeId = workflowTypeId;
        this.label = label;
        this.id = id;
        this.environments = null;
        this.workflowData = null;
        this.workflowTaskTypes = null;
        this.tasks = [];
    }
}